import { Directive, Input, ElementRef, ViewContainerRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTxt]'
})
export class TxtDirective implements OnInit {

  constructor(public renderer: Renderer2, public el: ElementRef, public viewContainer: ViewContainerRef) { }

  @Input() appTxt: string;

  ngOnInit() {
    if (this.appTxt != null && this.appTxt.length > 0) {
      const split = this.appTxt.split('~');
      if (split.length >= 1) {
        this.renderer.createText(this.appTxt.split('~')[0]);
      }
      if (split.length >= 2) {
        if (this.appTxt.split('~')[1] === 'M') {
          this.el.nativeElement.innerHTML = this.appTxt.split('~')[0] + '<span class="mandatory"> *</span>';
        }
      }
    }
  }
}
